module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 large-2"
  }, [_c('selectize-vehicle', {
    on: {
      "optionSelected": _vm.setVehicle,
      "optionRemoved": _vm.unsetVehicle
    }
  })], 1), (_vm.showCloneForm) ? _c('div', {
    staticClass: "column small-12 large-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataCsv),
      expression: "dataCsv"
    }],
    attrs: {
      "rows": "10",
      "placeholder": "Paste your csv"
    },
    domProps: {
      "value": (_vm.dataCsv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataCsv = $event.target.value
      }
    }
  })]) : _vm._e()]), (_vm.firstRows && _vm.showCloneForm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-4 large2"
  }, [_c('label', [_vm._v("CSV separator")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sep),
      expression: "sep"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sep = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v("select your csv delimiter")]), _c('option', {
    attrs: {
      "value": "\t"
    }
  }, [_vm._v("tab(\\t)")]), _c('option', {
    attrs: {
      "value": ";"
    }
  }, [_vm._v(";")]), _c('option', {
    attrs: {
      "value": ","
    }
  }, [_vm._v(",")])])]), _c('div', {
    staticClass: "column small-4 large2"
  }, [_c('label', [_vm._v("Remove first row header")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deletedCsvField),
      expression: "deletedCsvField"
    }],
    ref: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deletedCsvField) ? _vm._i(_vm.deletedCsvField, null) > -1 : (_vm.deletedCsvField)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.deletedCsvField,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deletedCsvField = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deletedCsvField = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deletedCsvField = $$c
        }
      }
    }
  })])]) : _vm._e(), (_vm.firstRows && _vm.showCloneForm) ? _c('div', {
    staticStyle: {
      "border": "1px solid blue",
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.firstRows[0]), function(row, index) {
    return _c('div', {
      staticClass: "column"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.headerColumn[index]),
        expression: "headerColumn[index]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.headerColumn, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "selected"
      },
      domProps: {
        "value": undefined
      }
    }, [_vm._v("select correct header")]), _c('option', {
      attrs: {
        "value": "vin"
      }
    }, [_vm._v("vin")]), _c('option', {
      attrs: {
        "value": "plate"
      }
    }, [_vm._v("plate")]), _c('option', {
      attrs: {
        "value": "hw_serial"
      }
    }, [_vm._v("serial")])])])
  }), 0), _vm._l((_vm.firstRows), function(row, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, _vm._l((row), function(i) {
      return _c('div', {
        staticClass: "column"
      }, [_c('span', [_vm._v(_vm._s(i))])])
    }), 0)
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.clonedisabled
    },
    on: {
      "click": _vm.clone
    }
  }, [_vm._v("clone")])])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-089e601c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CloneVehicle.vue
// module id = 2116
// module chunks = 1